<template>
  <div class="">
    <div class="">
      <div class="">
        <div class="text-2xl mt-3 lg:mt-0 text-[#09518C]">
          Contribution Schedule
        </div>
        <p class="py-1 lg:py-4">
          <a
            class="text-[#8dc63f] font-bold"
            href="https://toolkitapi-staging.armpension.com/public/sample/PaymentScheduleTemplate.xlsx"
            target="_blank"
            >Download</a
          >
          a copy of schedule template
        </p>
        <div class="py-1">
          <form
            @submit.prevent="validateContributionSchedule"
            class="lg:mr-48 lg:w-1/2 w-full"
            :class="{ valid: !v$.$error && v$.$dirty, error: v$.$error }"
            v-show="firstPage === true"
          >
            <div class="my-2">
              <p class="block text-gray-700 text-sm font-bold mb-2">
                <span class="text-red-500">*</span> Amount Paid in Naira
              </p>
              <div class="flex">
                <input
                  class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                  formControlName="amount"
                  placeholder="5000"
                  type="number"
                  v-model.number="state.amount_paid"
                />
              </div>
              <div
                class="input-errors text-sm text-red-500 mt-1"
                v-for="error of v$.amount_paid?.$errors"
                :key="error.$uid"
              >
                <div class="error-msg">Amount is required</div>
              </div>
            </div>
            <div class="my-4">
              <p class="block text-gray-700 text-sm font-bold mb-2">
                <span class="text-red-500">*</span> Remittance Period
              </p>
              <div class="flex">
                <select
                  v-model="state.remittance_period"
                  class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                >
                  <option value="">Select</option>
                  <option value="single">Single</option>
                  <option value="multiple">Multiple</option>
                </select>
              </div>
              <div
                class="input-errors text-sm text-red-500 mt-1"
                v-for="error of v$.remittance_period?.$errors"
                :key="error.$uid"
              >
                <div class="error-msg">Remittance Period is required</div>
              </div>
            </div>
            <div class="my-4">
              <p class="block text-gray-700 text-sm font-bold mb-2">
                <span class="text-red-500">*</span> Payment Status
              </p>
              <div class="flex">
                <select
                  v-model="state.paymentStatus"
                  class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                >
                  <option value="" disabled>Select</option>
                  <option value="paid">Paid</option>
                  <option value="unpaid">Unpaid</option>
                </select>
              </div>
              <div
                class="input-errors text-sm text-red-500 mt-1"
                v-for="error of v$.paymentStatus?.$errors"
                :key="error.$uid"
              >
                <div class="error-msg">Payment status is required</div>
              </div>
            </div>
            <div class="my-4" v-if="state.paymentStatus === 'paid'">
              <p class="block text-gray-700 text-sm font-bold mb-2">
                <span class="text-red-500">*</span> Payment Date
              </p>
              <div class="flex w-full">
                <Datepicker
                  :enableTimePicker="false"
                  class="appearance-none w-full rounded py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                  style="background: none; border: none"
                  v-model="state.paymentDate"
                  month-name-format="long"
                ></Datepicker>
              </div>
              <div
                class="input-errors text-sm text-red-500 mt-1"
                v-for="error of v$.paymentDate?.$errors"
                :key="error.$uid"
              >
                <div class="error-msg">Payment date is required</div>
              </div>
            </div>
            <div v-if="state.remittance_period === 'multiple'">
              <div class="my-4">
                <p class="block text-gray-700 text-sm font-bold mb-2">
                  <span class="text-red-500">*</span> Payment Period Date (From)
                </p>
                <div class="flex">
                  <Datepicker
                    :enableTimePicker="false"
                    type="month"
                    month-picker
                    class="appearance-none w-full rounded py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                    style="background: none; border: none"
                    v-model="state.startPaymentDate"
                  ></Datepicker>
                </div>
                <div
                  class="input-errors text-sm text-red-500 mt-1"
                  v-for="error of v$.startPaymentDate?.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">Payment start date is required</div>
                </div>
              </div>
              <div class="my-4">
                <p class="block text-gray-700 text-sm font-bold mb-2">
                  <span class="text-red-500">*</span> Payment Period Date (To)
                </p>
                <div class="flex">
                  <Datepicker
                    :enableTimePicker="false"
                    month-picker
                    class="appearance-none w-full rounded py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                    style="background: none; border: none"
                    v-model="state.endPaymentDate"
                    month-name-format="long"
                  ></Datepicker>
                </div>
                <div
                  class="input-errors text-sm text-red-500 mt-1"
                  v-for="error of v$.endPaymentDate?.$errors"
                  :key="error.$uid"
                >
                  <div class="error-msg">Payment end date is required</div>
                </div>
              </div>
            </div>
            <div class="my-4">
              <p class="block text-gray-700 text-sm font-bold mb-2">
                <span class="text-red-500">*</span>
                Additional Notes
              </p>
              <div class="flex">
                <textarea
                  v-model="state.additionalNotes"
                  rows="6"
                  class="shadow appearance-none w-full border bg-gray-200 rounded px-2 py-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                  cols="20"
                  placeholder="Enter any notes here..."
                >
                </textarea>
              </div>
              <div
                class="input-errors text-sm text-red-500 mt-1"
                v-for="error of v$.additionalNotes?.$errors"
                :key="error.$uid"
              >
                <div class="error-msg">
                  Additional note is required is required
                </div>
              </div>
            </div>
            <div class="border-dotted border-2 bg-gray-100 rounded p-7 flex">
              <div class="flex justify-center items-center w-full">
                <label
                  for="dropzone-file"
                  class="flex flex-col justify-center items-center w-full text-center h-36 bg-gray-50 rounded-lg border-2 border-gray-300 border-dashed cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                >
                  <div
                    class="flex flex-col justify-center items-center pt-5 pb-6"
                  >
                    <svg
                      aria-hidden="true"
                      class="mb-3 w-10 h-10 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                      ></path>
                    </svg>
                    <p
                      v-if="state.getFileName === ''"
                      class="mb-2 text-sm text-gray-500 dark:text-gray-400"
                    >
                      <span class="font-semibold">
                        Click to upload contribution schedule</span
                      >
                    </p>

                    <p
                      v-if="state.getFileName === ''"
                      class="text-xs text-gray-500 dark:text-gray-400"
                    >
                      .xls, .xlsx, .csv
                    </p>
                    <div class="text-[#09518c]">{{ state.getFileName }}</div>
                  </div>
                  <input
                    id="dropzone-file"
                    type="file"
                    accept=".xls, .xlsx, .csv"
                    @change="onFileChange"
                    class="hidden"
                  />
                </label>
              </div>
            </div>
            <div
              class="input-errors text-sm text-red-500 mt-1"
              v-for="error of v$.getFileName?.$errors"
              :key="error.$uid"
            >
              <div class="error-msg">File upload is required</div>
            </div>

            <div
              v-if="failValidationMessage"
              class="bg-red-600 text-white text-center my-3 rounded-md p-4"
            >
              <font-awesome-icon class="mr-2" icon="fa-exclamation-triangle" />
              {{ failValidationMessage }}
            </div>

            <div class="my-4 flex">
              <button
                type="submit"
                class="text-white rounded-lg w-full h-14 relative hover:text-[#F58220] hover:bg-white hover:border-[#8DC63F] border transition-colors duration-300"
                :disabled="loadingValidation === true"
                :class="
                  loadingValidation === true ? 'bg-gray-600' : 'bg-[#8dc63f]'
                "
              >
                <span
                  v-if="loadingValidation === true"
                  class="flex justify-center"
                >
                  <LoadingSpinner class="h-10 w-10 -mt-10" />
                </span>
                <span v-else>Validate Schedule </span>
              </button>
            </div>
          </form>
          <div v-show="firstPage === false">
            <!-- <p>Validation Result</p> -->
            <div class="overflow-x-auto">
              <div v-if="!successValidationMessage">
                <table id="paymentHistory" class="w-full">
                  <thead>
                    <tr class="bg-gray-200 text-gray-700 text-left">
                      <th class="px-4 py-2 text-[#09518C]">PIN</th>
                      <th class="px-4 py-2 text-[#09518C]">Name on File</th>
                      <th class="px-4 py-2 text-[#09518C]">
                        Name on ARM Database
                      </th>
                      <th class="px-4 py-2 text-[#09518C]">Message</th>
                      <th class="px-4 py-2 text-[#09518C]">Status</th>
                    </tr>
                  </thead>
                  <tbody class="text-sm" v-if="staffs.length !== 0">
                    <tr v-for="item in staffs" :key="item.id">
                      <td class="px-4 py-2">{{ item?.pin }}</td>
                      <td class="px-4 py-2">{{ item?.nameOnFile }}</td>
                      <td class="px-4 py-2">{{ item?.nameOnDb }}</td>
                      <td class="px-4 py-2">{{ item?.message }}</td>
                      <td class="px-4 py-2">
                        <span>
                          {{ item?.status }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div v-if="!successValidationMessage">
                <div
                  v-if="warningCount.length > 0 || failureCount.length > 0"
                  class="bg-red-600 text-white text-sm text-center my-3 rounded-md p-4"
                >
                  <font-awesome-icon
                    class="mr-2 shadow-bo"
                    icon="fa-exclamation-triangle"
                  />
                  At least one of the rows has a name mismatch error, (The name
                  on the file is different from the name on our database).
                  Proceeding to submit a contribution schedule means you consent
                  to give ARM Pension the go-ahead to process these
                  transactions.
                </div>
              </div>

              <div
                v-if="!canProceedTotal"
                class="bg-red-600 text-white text-sm text-center my-3 rounded-md p-4"
              >
                <font-awesome-icon
                  class="mr-2"
                  icon="fa-exclamation-triangle"
                />
                The Uploaded Amount on the Payment Schedule does not match with
                the Amount Paid field. You can not proceed until the amount paid
                field value matches the amount on the schedule
              </div>

              <div
                v-if="successValidationMessage && canProceedTotal"
                class="bg-[#8dc63f] text-white text-center my-3 rounded-md p-4"
              >
                <font-awesome-icon class="mr-2" icon="fa-check-circle" />
                {{ successValidationMessage }}
              </div>

              <div
                v-if="failValidationMessage"
                class="bg-red-600 text-white text-center my-3 rounded-md p-4"
              >
                <font-awesome-icon
                  class="mr-2"
                  icon="fa-exclamation-triangle"
                />
                {{ failValidationMessage }}
              </div>
            </div>
            <div class="my-4 flex justify-center">
              <button
                @click="firstPage = true"
                :disabled="loadingScheduleUpload === true"
                class="bg-yellow-600 text-white rounded-lg w-40 py-3 mr-3"
              >
                Back
              </button>
              <button
                :disabled="!canDoFinalSubmission"
                :class="!canDoFinalSubmission ? 'bg-gray-600' : 'bg-[#8dc63f]'"
                @click="submitContributionSchedule"
                class="bg-[#8dc63f] hover:text-[#F58220] hover:bg-white hover:border-[#8DC63F] border transition-colors duration-300 text-white rounded-lg w-64 py-3 px-4"
              >
                <span
                  v-if="loadingScheduleUpload === true"
                  class="flex justify-center"
                >
                  <LoadingSpinner class="h-10 w-10 -mt-10" />
                </span>

                <div v-else>Submit Schedule</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ContributionScheduleModal
      :isModalOpen="isModalOpen"
      :exitUploadMessageError="exitUploadMessageError"
      :successContributionMessage="successContributionMessage"
      @close="isModalOpen = false"
    />
  </div>
</template>

<script>
import { reactive, ref } from "@vue/reactivity";
import { toolkitAxios, engageAxios } from "@/env";
import { useStore } from "vuex";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import ContributionScheduleModal from "@/components/modals/ContributionScheduleModal.vue";
export default {
  components: {
    LoadingSpinner,
    ContributionScheduleModal,
  },
  setup() {
    const date = ref({
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
    });
    const startPaymentDate = ref({
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
    });
    const endPaymentDate = ref({
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
    });
    const paymentDate = ref(new Date());
    const additionalNotes = ref("");
    const amount_paid = ref("");
    const upload_file = ref("");
    const getFileName = ref("");
    const remittance_period = ref("");
    const paymentStatus = ref("");
    const theFile = ref("");
    const loadingValidation = ref(false);
    const loadingScheduleUpload = ref(false);
    const firstPage = ref(true);
    const staffs = ref("");
    const warningCount = ref("");
    const failureCount = ref("");
    const canDoFinalSubmission = ref("");
    const canProceedTotal = ref(true);
    const successValidationMessage = ref("");
    const failValidationMessage = ref("");
    const successContributionMessage = ref("");
    const exitUploadMessageError = ref("");
    const isModalOpen = ref(false);
    const getLink = ref(toolkitAxios);
    const store = useStore();
    const state = reactive({
      startPaymentDate: new Date(),
      endPaymentDate: new Date(),
      paymentDate: new Date(),
      additionalNotes: "",
      amount_paid: "",
      paymentStatus: "",
      remittance_period: "",
      getFileName: "",
    });

    const rules = {
      amount_paid: { required },
      paymentStatus: { required },
      additionalNotes: { required },
      getFileName: { required },
      paymentDate: {
        requiredIf: paymentStatus === "paid",
      },
      remittance_period: { required },
      startPaymentDate: {
        requiredIf: remittance_period == "multiple",
      },
      endPaymentDate: {
        requiredIf: remittance_period == "multiple",
      },
    };

    const v$ = useVuelidate(rules, state);

    const format = (date) => {
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${month}/${year}`;
    };

    const onFileChange = (e) => {
      const file = e.target.files[0];
      theFile.value = file;
      const reader = new FileReader();

      reader.addEventListener(
        "load",
        () => {
          upload_file.value = reader.result;
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
      state.getFileName = file.name;
    };

    const validateContributionSchedule = async () => {
      v$.value.$touch();
      successValidationMessage.value = null;

      if (v$.value.$invalid) return;

      loadingValidation.value = true;

      let formData = new FormData();
      formData.append("total_amount", state.amount_paid);
      formData.append("fileType", state.getFileName.split(".")[1]);
      formData.append("document", theFile.value, "document");

      await toolkitAxios
        .post("employer/contribution/validate", formData)
        .then((res) => {
          firstPage.value = false;
          exitUploadMessageError.value = "";

          if (res.data.data.rows && res.data.data.rows?.length > 0) {
            staffs.value = res.data.data.rows;

            warningCount.value = staffs.value?.filter(
              (item) => item?.status === "warning"
            );

            failureCount.value = staffs.value?.filter(
              (item) => item?.status === "fail"
            );
          } else {
            successValidationMessage.value =
              "Validation passed successfully, you may now submit your contribution schedule.";
          }

          canProceedTotal.value = res.data.data.canProceedTotal;

          canDoFinalSubmission.value =
            res?.data?.data?.canProceed && res?.data?.data?.canProceedTotal;

          failValidationMessage.value = "";
        })
        .catch((e) => {
          console.log(e.response.data.message, "error");
          failValidationMessage.value = e.response?.data?.message;
        })
        .finally(() => {
          loadingValidation.value = false;
        });
    };

    const submitContributionSchedule = async () => {
      loadingScheduleUpload.value = true;

      let finalDesc;

      finalDesc =
        "Payment Status: " +
        state.paymentStatus +
        " \n " +
        "Remittance Period: " +
        state.remittance_period +
        " \n " +
        "Payment Date: " +
        state.paymentDate +
        " \n " +
        "Amount: " +
        state.amount_paid +
        " \n ";

      if (state.startPaymentDate !== "") {
        finalDesc +=
          "Payment Period From Date: " + state.startPaymentDate + " \n ";
      }

      if (state.endPaymentDate !== "") {
        finalDesc +=
          "Payment Period End Date: " + state.endPaymentDate + " \n ";
      }

      if (state.additionalNotes !== "") {
        finalDesc += "Additional Notes: " + state.additionalNotes + " \n ";
      }

      const finalDto = {
        caseOriginCode: "700000008",
        employerCode: store.state.getLoggedInUser.code,
        interactionType: "700000000",
        interactionCategory: "c810db7a-081d-eb11-a813-000d3a64a52d",
        interactionSubCategory: "ec9cd856-091d-eb11-a813-000d3a64a52d",
        caseDescription: finalDesc,
        documents: upload_file.value,
        // agentCode: store.state.getLoggedInUser.rmu_code,
        subject: store.state.getLoggedInUser.code + "-Contribution Schedule",
      };

      return new Promise((resolve, reject) => {
        engageAxios
          .post("crm/case/employer/createcase", finalDto)

          .then((res) => {
            let postData = new FormData();
            postData.append("code", store.state.getLoggedInUser.code);
            postData.append("period", state.remittance_period);
            postData.append("amount", state.amount_paid);
            postData.append("type", state.paymentStatus);
            postData.append("from", state.startPaymentDate);
            postData.append("agentCode", store.state.getLoggedInUser.rmu_code);
            postData.append("document", theFile.value);
            if (state.endPaymentDate !== "") {
              postData.append("to", state.endPaymentDate);
            }

            if (res.data.status != "fail") {
              postData.append("caseNo", res.data.data.caseNumber);

              toolkitAxios
                .post("case/contribution", postData)
                .then(() => {
                  // console.log("toolkitresponse", response);
                  firstPage.value = true;
                  successContributionMessage.value = res.data.data.caseNumber;
                  isModalOpen.value = true;
                  loadingScheduleUpload.value = false;
                })

                .catch(() => {
                  exitUploadMessageError.value =
                    "An error occured when submitting your request, please try again later.";

                  isModalOpen.value = true;
                  // console.log("na toolkit catch dey run", error);
                });

              state.paymentStatus = "";
              state.remittance_period = "";
              state.amount_paid = "";
              state.paymentStatus = "";
              state.startPaymentDate = "";
              state.theFile = "";
              state.getFileName = "";
              state.additionalNotes = "";

              v$.value.$reset();
            } else {
              isModalOpen.value = true;
              loadingScheduleUpload.value = false;

              exitUploadMessageError.value =
                "An error occured when submitting your request, please try again later.";
            }

            resolve(true);
          })
          .catch((error) => {
            isModalOpen.value = true;
            loadingScheduleUpload.value = false;

            exitUploadMessageError.value =
              "An error occured when submitting your request, please try again later.";

            loadingScheduleUpload.value = false;

            reject(error);
          });
        // .finally(() => {
        //   loadingScheduleUpload.value = false;
        // });
      });
    };

    return {
      date,
      amount_paid,
      upload_file,
      onFileChange,
      validateContributionSchedule,
      getFileName,
      remittance_period,
      format,
      theFile,
      staffs,
      warningCount,
      failureCount,
      canDoFinalSubmission,
      canProceedTotal,
      loadingValidation,
      firstPage,
      startPaymentDate,
      endPaymentDate,
      additionalNotes,
      paymentDate,
      paymentStatus,
      successValidationMessage,
      failValidationMessage,
      store,
      successContributionMessage,
      exitUploadMessageError,
      isModalOpen,
      submitContributionSchedule,
      loadingScheduleUpload,
      rules,
      state,
      v$,
      getLink,
    };
  },
};
</script>

<style scoped>
.px-3 {
  padding-left: 0px;
  padding-right: 0px;
}
</style>

<style>
.dp__input {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity)) !important;
}
</style>
